import { z } from 'zod';
import { PropertySchema } from '../../../services/properties/response/ShowPropertiesResponse';

export const UpdatePropertyResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: PropertySchema,
});

export type UpdatePropertyResponseType = z.infer<typeof UpdatePropertyResponse>;
